/**
 * Replaces `#app` content with a controlled error message (no prior telemetry).
 * For bootstrap failures where neither shell nor notifications exist yet.
 */
export type ShowFatalAppErrorOptions = {
  title: string;
  hint: string;
  error: unknown;
  /** Default: `location.reload()`. */
  onRetry?: () => void;
  retryLabel?: string;
};
/** Shows fatal app error. */
export function showFatalAppError(options: ShowFatalAppErrorOptions): void {
  const app = document.getElementById('app');
  if (!app) return;
  const detail = options.error instanceof Error ? options.error.message : String(options.error);
  app.replaceChildren();
  const wrap = document.createElement('div');
  wrap.setAttribute('role', 'alert');
  wrap.style.cssText =
    'padding:2rem;font-family:system-ui,sans-serif;max-width:36rem;margin:2rem auto;line-height:1.5';
  const title = document.createElement('p');
  title.style.fontWeight = '600';
  title.textContent = options.title;
  const hint = document.createElement('p');
  hint.style.fontSize = '0.9rem';
  hint.style.color = '#444';
  hint.textContent = options.hint;
  const pre = document.createElement('pre');
  pre.style.whiteSpace = 'pre-wrap';
  pre.style.fontSize = '0.85rem';
  pre.style.marginTop = '1rem';
  pre.textContent = detail;
  const btn = document.createElement('button');
  btn.type = 'button';
  btn.textContent = options.retryLabel ?? 'Reintentar';
  btn.style.marginTop = '1rem';
  btn.style.padding = '0.5rem 1rem';
  btn.onclick = (): void => {
    (options.onRetry ?? (() => globalThis.location.reload()))();
  };
  wrap.append(title, hint, pre, btn);
  app.append(wrap);
}
